var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: {
            "flex-direction": "row",
            "line-height": "28px",
            "min-width": "1600px"
          }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "booking" },
              model: {
                value: _vm.job.booking,
                callback: function($$v) {
                  _vm.$set(_vm.job, "booking", $$v)
                },
                expression: "job.booking"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "customs" },
              on: {
                change: function(val) {
                  _vm.job.customsBroker = val ? _vm.job.customsBroker : 0
                  _vm.job.customsDeclarationType = val
                    ? _vm.job.customsDeclarationType
                    : -1
                }
              },
              model: {
                value: _vm.job.customs,
                callback: function($$v) {
                  _vm.$set(_vm.job, "customs", $$v)
                },
                expression: "job.customs"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CustomsDeclaration")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "comercialInspectation" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "heating" },
              model: {
                value: _vm.job.heating,
                callback: function($$v) {
                  _vm.$set(_vm.job, "heating", $$v)
                },
                expression: "job.heating"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Fumigation")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "itmService" },
              model: {
                value: _vm.job.itmService,
                callback: function($$v) {
                  _vm.$set(_vm.job, "itmService", $$v)
                },
                expression: "job.itmService"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.ForeignTrade")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.readonly, no: "headwayTail" },
              model: {
                value: _vm.job.headwayTail,
                callback: function($$v) {
                  _vm.$set(_vm.job, "headwayTail", $$v)
                },
                expression: "job.headwayTail"
              }
            },
            [_vm._v(_vm._s(_vm.$t("RailwayExport.isHeadwayTail")))]
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["button_insurance_toInsure"],
                  expression: "['button_insurance_toInsure']"
                }
              ],
              attrs: { disabled: _vm.isEdit, no: "toInsure", type: "primary" },
              on: { click: _vm.toInsure }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Insure")))]
          ),
          _c("span", { staticStyle: { "margin-left": "20px" } }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
          ]),
          _c(
            "el-radio-group",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { disabled: _vm.readonly, no: "lob" },
              on: { change: _vm.lobChangeHandler },
              model: {
                value: _vm.job.lob,
                callback: function($$v) {
                  _vm.$set(_vm.job, "lob", $$v)
                },
                expression: "job.lob"
              }
            },
            [
              _c("el-radio", { attrs: { no: "RE", label: "RE" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Export")))
              ]),
              _c("el-radio", { attrs: { no: "RI", label: "RI" } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_JobTypeImport")))
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section top", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BasicInfo")))
          ]),
          _c(
            "el-form",
            {
              attrs: {
                disabled: _vm.readonly,
                inline: true,
                "label-width": "135px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.Cargo_BusinessNo"),
                    "label-width": "125px"
                  }
                },
                [
                  _c("el-input", {
                    staticClass: "job-no-color input2",
                    attrs: { no: "jobNo", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_WarehouseNo") } },
                [
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: { no: "warehouseNo" },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                [
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "quotationNo",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c("div", [
            _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "125px" } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Payment.consignationCompany"))
                            )
                          ]
                        ),
                        _vm.accountObjectControlMode === 2
                          ? _c("cargo-sales-company-select", {
                              attrs: {
                                no: "customerId",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                placeholder: _vm.$t("SeaExport.RequiredItem")
                              },
                              on: {
                                parentCallBack: _vm.txtCustomerId_changeHandler
                              }
                            })
                          : _c("cargo-company-select", {
                              attrs: {
                                no: "customerId",
                                disabled: !(
                                  !_vm.job.mbl && _vm.electricBusinessBtnEnable
                                ),
                                "method-params": {
                                  customer: true,
                                  active: true
                                },
                                "check-credit": true,
                                job: _vm.job,
                                "default-value": _vm.job.customerId || "",
                                "static-options": _vm.customerCmpList,
                                placeholder: _vm.$t("SeaExport.RequiredItem"),
                                "custom-style": "width:260px"
                              },
                              on: { change: _vm.txtCustomerId_changeHandler }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.contactPerson") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "input2",
                            attrs: {
                              no: "customerContact",
                              disabled: !_vm.electricBusinessBtnEnable,
                              filterable: "",
                              "allow-create": true,
                              placeholder: ""
                            },
                            on: { change: _vm.tfLinkman_closeHandler },
                            model: {
                              value: _vm.job.customerContact,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customerContact", $$v)
                              },
                              expression: "job.customerContact"
                            }
                          },
                          _vm._l(_vm.contactList, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.contactPerson,
                                value: item.contactPerson
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: { label: _vm.$t("SeaExport.Tel") }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "contactTelephone",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactTelephone,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactTelephone", $$v)
                            },
                            expression: "job.contactTelephone"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isShowContactPersonDetail,
                            expression: "!isShowContactPersonDetail"
                          }
                        ],
                        attrs: {
                          label: _vm.$t("SeaExport.Fax"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "contactFax",
                            disabled: !_vm.electricBusinessBtnEnable,
                            maxlength: "32"
                          },
                          model: {
                            value: _vm.job.contactFax,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "contactFax", $$v)
                            },
                            expression: "job.contactFax"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "blue",
                        attrs: { "label-width": "125px" }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("Payment.sales")))]
                        ),
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "sales",
                            disabled: !(
                              !_vm.job.trustFromJob &&
                              _vm.electricBusinessBtnEnable &&
                              (!_vm.validateCustomerSales ||
                                (_vm.isSpecifiedSalesBusiness &&
                                  _vm.validateCustomerSales))
                            ),
                            "method-params": {
                              officeId:
                                !_vm.isSpecifiedSalesBusiness &&
                                _vm.salesOfficeCheck
                                  ? _vm.$store.getters.currentOfficeId
                                  : "",
                              category: "role",
                              shape: "sales"
                            },
                            "default-value": _vm.job.sales || "",
                            "static-options": _vm.salesList,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { change: _vm.txtSales_changeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("queryJob.salesDepartment")))]
                        ),
                        _c("cargo-department-new-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "salesOffice",
                            disabled: !(
                              _vm.job.sales > 0 && _vm.job.salesDepartment > 0
                            ),
                            "sales-id": _vm.job.sales,
                            "office-id": _vm.job.salesOffice,
                            "department-id": _vm.job.salesDepartment,
                            "show-office-prefix": false,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.salesDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "blue" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "blue",
                            attrs: { slot: "label" },
                            slot: "label"
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.SalesCompany")))]
                        ),
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: {
                            no: "txtSalesOffice",
                            disabled: true,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          model: {
                            value: _vm.txtSalesOffice,
                            callback: function($$v) {
                              _vm.txtSalesOffice = $$v
                            },
                            expression: "txtSalesOffice"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.SalesOfGoods"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "cargoSalesId",
                            "method-params": {
                              category: "role",
                              shape: "salesOfGoods"
                            },
                            "default-value": _vm.job.cargoSalesId || "",
                            "static-options": _vm.cargoSalesList,
                            placeholder: " "
                          },
                          on: { change: _vm.cargoSalesChargeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("FileHistory.operation"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "op",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "op",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.op || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.op
                          },
                          on: { change: _vm.txtOPChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("queryJob.operationDepartment") }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "opDepartment",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "office-id": _vm.job.opOffice,
                            enables: true,
                            "department-id": _vm.job.opDepartment,
                            placeholder: " "
                          },
                          on: {
                            change: function(p) {
                              _vm.job.opDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("SeaExport.OperationCompany") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "opOffice",
                            disabled: _vm.isEntrustOrder(),
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.opOffice || "",
                            placeholder: " "
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.opOffice = p.value
                              _vm.opOfficeChargeHandler()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("queryJob.Documents"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dc",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "doc",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.dc || "",
                            "static-options":
                              _vm.userPortRoleData.doc || _vm.dcList,
                            placeholder: " "
                          },
                          on: { change: _vm.dcChangeHandler }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.customerService"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csr",
                            disabled: Boolean(_vm.job.trustFromJob),
                            "method-params": {
                              category: "role",
                              shape: "csr",
                              officeId: _vm.job.opOffice
                            },
                            "default-value": _vm.job.csr || "",
                            "static-options":
                              _vm.userPortRoleData.csr || _vm.csrList,
                            placeholder: " "
                          },
                          on: { change: _vm.csrChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Payment.planner") } },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "planner",
                            "method-params": {
                              category: "role",
                              shape: "railwayLine",
                              officeId: _vm.$store.getters.currentOfficeId
                            },
                            "default-value": _vm.job.planner || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.railwayLine
                          },
                          on: { change: _vm.txtPlannerChangeHandler }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.OverseaCustomerService")
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          ref: "overseaOp",
                          staticClass: "input2",
                          attrs: {
                            no: "overseaOp",
                            "default-value": _vm.job.overseaOp || "",
                            "method-params": {
                              category: "role",
                              shape: "overseaOp"
                            },
                            "static-options": _vm.isHc
                              ? null
                              : _vm.userPortRoleData.overseaOp ||
                                _vm.overseaAgentUsersList,
                            "merge-load": true
                          },
                          on: {
                            change: function(p) {
                              _vm.job.overseaOp = p.value
                              _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                                _vm.view,
                                p
                              )
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.FieldOperation"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-user-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "siteOP",
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "siteOp"
                            },
                            "default-value": _vm.job.siteOP || "",
                            placeholder: " ",
                            "static-options": _vm.userPortRoleData.siteOp
                          },
                          on: {
                            change: function(p) {
                              _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.Customer_Service"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrDepartment",
                            "office-id": Number(_vm.job.csrOffice),
                            enables: true,
                            "department-id": Number(_vm.job.csrDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.csrDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "csrOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.csrOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.csrOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.Documentation_Department")
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcDepartment",
                            "office-id": Number(_vm.job.dcOffice),
                            enables: true,
                            "department-id": Number(_vm.job.dcDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.dcDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.DocumentOffice"),
                          "label-width": "100px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "dcOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.dcOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.dcOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-form",
                  {
                    attrs: {
                      disabled: _vm.readonly,
                      inline: true,
                      "label-width": "135px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Payment.businessReferenceNumber"),
                          "label-width": "125px"
                        }
                      },
                      [
                        _c("cargo-input", {
                          staticClass: "input2",
                          attrs: { no: "customerRefNo", trim: true },
                          model: {
                            value: _vm.job.customerRefNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "customerRefNo", $$v)
                            },
                            expression: "job.customerRefNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.poNoRed ? "poNoClass" : "",
                        attrs: { label: _vm.$t("Payment.itemNo") }
                      },
                      [
                        _c("el-input", {
                          staticClass: "input2",
                          attrs: { no: "poNo" },
                          model: {
                            value: _vm.job.poNo,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "poNo", $$v)
                            },
                            expression: "job.poNo"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("RailwayExport.plannerDepartment")
                        }
                      },
                      [
                        _c("cargo-department-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerDepartment",
                            "office-id": Number(_vm.job.plannerOffice),
                            enables: true,
                            "department-id": Number(_vm.job.plannerDepartment)
                          },
                          on: {
                            change: function(p) {
                              _vm.job.plannerDepartment = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: _vm.$t("RailwayExport.plannerOffice") }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticClass: "input2",
                          attrs: {
                            no: "plannerOffice",
                            disabled: true,
                            "select-type": _vm.TYPE_NAMES.basic_data_Office,
                            filterable: "",
                            "default-value": _vm.job.plannerOffice || ""
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.job.plannerOffice = p.value
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.isAddUserDefinedRoles
                  ? _c(
                      "el-form",
                      {
                        attrs: {
                          disabled: _vm.readonly,
                          inline: true,
                          "label-width": "135px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole1"),
                              "label-width": "125px"
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              staticClass: "input2",
                              attrs: {
                                no: "userDefinedRoleId1",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole1"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId1 || "",
                                placeholder: " ",
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole1
                              },
                              on: { change: _vm.userDefinedRoleId1Handler }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                            }
                          },
                          [
                            _c("cargo-user-select", {
                              staticClass: "input2",
                              attrs: {
                                no: "userDefinedRoleId2",
                                "method-params": {
                                  officeId: _vm.$store.getters.currentOfficeId,
                                  category: "role",
                                  shape: "userDefinedRole2"
                                },
                                "default-value":
                                  _vm.job.userDefinedRoleId2 || "",
                                placeholder: " ",
                                "static-options":
                                  _vm.userPortRoleData.userDefinedRole2
                              },
                              on: { change: _vm.userDefinedRoleId2Handler }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.job.preverifyState === 3,
                    expression: "job.preverifyState===3"
                  }
                ],
                staticStyle: { display: "flex" }
              },
              [
                _c(
                  "span",
                  { staticStyle: { width: "100px", display: "inline-block" } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DenialReason")))]
                ),
                _c("el-input", {
                  staticStyle: { width: "260px" },
                  attrs: {
                    no: "bookingRefuseNote",
                    type: "textarea",
                    rows: 3,
                    disabled: true
                  },
                  model: {
                    value: _vm.job.bookingRefuseNote,
                    callback: function($$v) {
                      _vm.$set(_vm.job, "bookingRefuseNote", $$v)
                    },
                    expression: "job.bookingRefuseNote"
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { "min-width": "1600px" } },
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShippingInformation")))
          ]),
          _c(
            "div",
            {
              staticClass: "form-item-w260",
              staticStyle: { display: "flex", "flex-direction": "row" }
            },
            [
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "125px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Shipper") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "shipperId",
                          disabled: _vm.readonly,
                          "method-params": { shipper: true, active: true },
                          "default-value": _vm.job.shipperId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateShipperList
                            : null
                        },
                        on: { change: _vm.shipperChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "CodeSearching", type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "shipperLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "shipperLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "shipperLine" + i,
                                i + 1 > 7 ? null : "shipperLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Shipper"),
                                _vm.mergeShipperLine(),
                                _vm.splitShipperLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["shipperLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "shipperLine" + i, $$v)
                            },
                            expression: "job['shipperLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transportType")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transportType",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_TransportationType,
                          filterable: "",
                          "default-value": _vm.job.transportType,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transportType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("RailwayExport.fullHalf")) + " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "fullHalf",
                          "select-type": _vm.TYPE_NAMES.local_cache_FullHalf,
                          filterable: "",
                          "default-value": _vm.job.fullHalf,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.fullHalf = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transportLine")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transportLine",
                          "select-type": _vm.TYPE_NAMES.basic_data_RailwayLine,
                          filterable: "",
                          "default-value": _vm.job.transportLine,
                          placeholder: _vm.$t("SeaExport.RequiredItem"),
                          "tag-name": "name"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transportLine = p.value
                            _vm.onTransportLineChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.ETD2")))]
                      ),
                      _c("el-date-picker", {
                        attrs: {
                          no: "etd",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        model: {
                          value: _vm.job.etd,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "etd", $$v)
                          },
                          expression: "job.etd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.lob === "RE",
                          expression: "job.lob==='RE'"
                        }
                      ],
                      attrs: { label: _vm.$t("RailwayExport.ETA2") }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "eta",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "eta", $$v)
                          },
                          expression: "job.eta"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.lob === "RI",
                          expression: "job.lob==='RI'"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("RailwayExport.ETA2")))]
                      ),
                      _c("el-date-picker", {
                        attrs: {
                          no: "eta",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          clearable: ""
                        },
                        model: {
                          value: _vm.job.eta,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "eta", $$v)
                          },
                          expression: "job.eta"
                        }
                      })
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "span",
                      {
                        staticClass: "blue",
                        attrs: { slot: "label" },
                        slot: "label"
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("RailwayExport.departureStation")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "departureStation",
                            "select-type":
                              _vm.TYPE_NAMES.basic_data_RailwayStation,
                            filterable: "",
                            "default-value": _vm.job.departureStation,
                            placeholder: _vm.$t("SeaExport.RequiredItem")
                          },
                          on: { parentCallBack: _vm.departureStationChange }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: {
                              width: "80px",
                              "padding-left": "5px"
                            },
                            attrs: { no: "transfer" },
                            model: {
                              value: _vm.job.transfer,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfer", $$v)
                              },
                              expression: "job.transfer"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.transfer,
                          expression: "job.transfer"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transferStation")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transferStation",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.job.transferStation
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transferStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.transitStation")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "transitStation",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.job.transitStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.transitStation = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("RailwayExport.destinationStation")
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationStation",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_RailwayStation,
                          filterable: "",
                          "default-value": _vm.job.destinationStation,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: { parentCallBack: _vm.destinationStationChange }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationCountry")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationCountry",
                          "select-type": _vm.TYPE_NAMES.basic_data_Country,
                          filterable: "",
                          "default-value": _vm.job.destinationCountry
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.destinationCountry = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SolicitationType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoSource",
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                          "default-value": _vm.job.cargoSource,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoSource = p.value
                            _vm.cargoSource_Change()
                            _vm.txtCargoSourceChangeHandler()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomJobType") } },
                    [
                      _c("cargo-advance-select", {
                        ref: "customJobType",
                        attrs: {
                          no: "customJobType",
                          "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                          filterable: "",
                          "static-options": _vm.getCustomJobType,
                          "default-value": _vm.job.customJobType,
                          placeholder: _vm.$t("Message.PleaseSelect")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customJobType = p.value
                            _vm.onCustomJobTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.portAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "portAgent",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            portAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.job.portAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.portAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("RailwayExport.forwardingAgent") }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "forwardingAgent",
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "method-params": {
                            companyLob: "railwayExport",
                            forwardingAgent: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.job.forwardingAgent || ""
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.forwardingAgent = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("queryJob.destinationAgent") } },
                    [
                      _c("cargo-company-select", {
                        ref: "destinationAgent",
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "destinationAgent",
                          "method-params": {
                            overseaAgent: true,
                            active: true,
                            companyLob: "railwayExport"
                          },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.destinationAgent || "",
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName"
                        },
                        on: { change: _vm.txtDestinationAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.cargoSource === "NC",
                          expression: "job.cargoSource==='NC'"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("queryJob.nominatedAgent")))]
                      ),
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "designationAgent",
                          "method-params": {
                            designationAgent: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.designationAgent || "",
                          "tag-name": "englishName",
                          placeholder: " "
                        },
                        on: { change: _vm.txtDesignationAgentChangeHandler }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: { no: "diffPlacesCollaborate" },
                      model: {
                        value: _vm.job.diffPlacesCollaborate,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "diffPlacesCollaborate", $$v)
                        },
                        expression: "job.diffPlacesCollaborate"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("RailwayExport.isDiffPlacesCollaborate"))
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.loadingPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "loadingPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            loadingPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.loadingPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.loadingPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.signBillPlaceCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "signBillPlaceCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            signBillPlaceCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.signBillPlaceCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.signBillPlaceCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticClass: "blue",
                      attrs: { no: "fullShipment" },
                      model: {
                        value: _vm.job.fullShipment,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "fullShipment", $$v)
                        },
                        expression: "job.fullShipment"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("RailwayExport.isFullShipment")))]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.dischargePortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "dischargePortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            dischargePortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.dischargePortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.dischargePortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("RailwayExport.destinationPortCompany")
                      }
                    },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          no: "destinationPortCompany",
                          "method-params": {
                            companyLob: "railwayExport",
                            destinationPortCompany: true,
                            active: true
                          },
                          "check-credit": true,
                          job: _vm.job,
                          tooltip: true,
                          "tooltip-tag-name": "englishName",
                          "default-value": _vm.job.destinationPortCompany || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.destinationPortCompany = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Consignee") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "consigneeId",
                          disabled: _vm.readonly,
                          "method-params": { consignee: true, active: true },
                          "default-value": _vm.job.consigneeId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateConsigneeList
                            : null
                        },
                        on: { change: _vm.consigneeChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "consigneeLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "consigneeLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "consigneeLine" + i,
                                i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.Consignee"),
                                _vm.mergeConsigneeLine(),
                                _vm.splitConsigneeLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["consigneeLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                            },
                            expression: "job['consigneeLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("RailwayExport.paymentMethod")) +
                              " "
                          )
                        ]
                      ),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "paymentMethod",
                          "select-type":
                            _vm.selectTypeNames.basic_data_PaymentMethod,
                          "method-params": {
                            companyLob: "railwayExport",
                            paymentMethod: true,
                            active: true
                          },
                          filterable: "",
                          "default-value": _vm.job.paymentMethod,
                          "tag-name":
                            this.$store.getters.language === "zh"
                              ? "chineseName"
                              : "englishName",
                          "tag-value": "code",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.paymentMethod = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.vessel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "vessel" },
                        model: {
                          value: _vm.job.vessel,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "vessel", $$v)
                          },
                          expression: "job.vessel"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("RailwayExport.voyageFlight") } },
                    [
                      _c("el-input", {
                        attrs: { no: "voyageFlight" },
                        model: {
                          value: _vm.job.voyageFlight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "voyageFlight", $$v)
                          },
                          expression: "job.voyageFlight"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { no: "containerLoadType" },
                          on: {
                            change: function($event) {
                              return _vm.containerLoadType_Change()
                            }
                          },
                          model: {
                            value: _vm.job.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "containerLoadType", $$v)
                            },
                            expression: "job.containerLoadType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: "FCL" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FCL")))
                          ]),
                          _c("el-radio", { attrs: { label: "LCL" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_DirectConsol"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: "BB" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CoLoadConsol"))
                            )
                          ]),
                          _c("el-radio", { attrs: { label: "BC" } }, [
                            _vm._v("Buyer Console")
                          ]),
                          _c("el-radio", { attrs: { label: "BULK" } }, [
                            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BulkCargo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.job.containerLoadType === "FCL" ||
                            _vm.job.containerLoadType === "BB",
                          expression:
                            "job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
                        }
                      ],
                      staticClass: "auto-width"
                    },
                    [
                      _c("booking-sea-eq-data-grid", {
                        ref: "bookingSeaEqDataGrid",
                        staticStyle: { width: "260px" },
                        attrs: {
                          value: _vm.seaEqList,
                          "container-load-type": _vm.job.containerLoadType,
                          "is-edit": _vm.isEdit,
                          job: _vm.job,
                          lob: "RE",
                          "hide-soc": true
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoType",
                          "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                          headers: [_vm.$t("Partners.chineseName")],
                          fields: ["chineseName"],
                          "filter-field-names": ["chineseName"],
                          "method-params": { sea: true },
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.cargoType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.cargoType = p.value
                            _vm.onCargoTypeChange()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.CommissionedNumberOfPackages")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "quantityContract",
                                  precision: 0,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(function() {
                                      _vm.job.quantityActual =
                                        _vm.job.quantityContract
                                    }, null)
                                  }
                                },
                                model: {
                                  value: _vm.job.quantityContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quantityContract", $$v)
                                  },
                                  expression: "job.quantityContract"
                                }
                              }),
                              _c("span")
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualQuantity")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "quantityActual",
                                  precision: 0,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(null, function() {
                                      _vm.job.quantityContract =
                                        _vm.job.quantityActual
                                    })
                                  }
                                },
                                model: {
                                  value: _vm.job.quantityActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "quantityActual", $$v)
                                  },
                                  expression: "job.quantityActual"
                                }
                              }),
                              _c("span")
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("SeaExport.CommissionedGrossWeight")
                              )
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "weightContract",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(function() {
                                      _vm.job.weightActual =
                                        _vm.job.weightContract
                                    }, null)
                                  }
                                },
                                model: {
                                  value: _vm.job.weightContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightContract", $$v)
                                  },
                                  expression: "job.weightContract"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualWeight")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "weightActual",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(null, function() {
                                      _vm.job.weightContract =
                                        _vm.job.weightActual
                                    })
                                  }
                                },
                                model: {
                                  value: _vm.job.weightActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "weightActual", $$v)
                                  },
                                  expression: "job.weightActual"
                                }
                              }),
                              _c("span", [_vm._v("KGS")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "short-item-input",
                          staticStyle: { width: "auto" }
                        },
                        [
                          _c("label", { staticStyle: { width: "135px" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("SeaExport.CommissionedVolume"))
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "cubageContract",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(function() {
                                      _vm.job.cubageActual =
                                        _vm.job.cubageContract
                                    }, null)
                                  }
                                },
                                model: {
                                  value: _vm.job.cubageContract,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageContract", $$v)
                                  },
                                  expression: "job.cubageContract"
                                }
                              }),
                              _c("span", [_vm._v("M³")])
                            ],
                            1
                          ),
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("SeaExport.ActualVolume")))
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "short-input",
                              class: _vm.readonly ? "short-input-disabled" : ""
                            },
                            [
                              _c("auto-number-input", {
                                attrs: {
                                  no: "cubageActual",
                                  precision: 3,
                                  min: 0
                                },
                                on: {
                                  change: function($event) {
                                    _vm.SEUtils.changeQWCRule(null, function() {
                                      _vm.job.cubageContract =
                                        _vm.job.cubageActual
                                    })
                                  }
                                },
                                model: {
                                  value: _vm.job.cubageActual,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "cubageActual", $$v)
                                  },
                                  expression: "job.cubageActual"
                                }
                              }),
                              _c("span", [_vm._v("M³")])
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Package") }
                    },
                    [
                      _c("cargo-packing-select", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          no: "packing",
                          disabled: _vm.readonly,
                          "default-value": _vm.job.packing,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.job.packing = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "135px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.NotifyParty") }
                    },
                    [
                      _c("cargo-company-select", {
                        class: _vm.isZh ? "shipper-input" : "shipper-input-en",
                        attrs: {
                          no: "notifyId",
                          disabled: _vm.readonly,
                          "method-params": { notify: true, active: true },
                          "default-value": _vm.job.notifyId || "",
                          placeholder: " ",
                          "static-options": _vm.hasChooseOwnTransceiverPermission
                            ? _vm.privateNotifyList
                            : null
                        },
                        on: { change: _vm.notifyChange }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "billAddressDialogVisible",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.billAddressDialog.visible = true
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                      )
                    ],
                    1
                  ),
                  _vm._l(7, function(i) {
                    return _c(
                      "el-form-item",
                      { key: i, staticClass: "auto-width" },
                      [
                        _c("cargo-input", {
                          ref: "notifyLine" + i,
                          refInFor: true,
                          attrs: {
                            no: "notifyLine" + i,
                            "auto-uppercase":
                              _vm.notUppercaseShipperConsigneNotify
                          },
                          on: {
                            change: function() {
                              return _vm.wrapAddr(
                                _vm.job,
                                "notifyLine" + i,
                                i + 1 > 7 ? null : "notifyLine" + (i + 1),
                                200
                              )
                            }
                          },
                          nativeOn: {
                            dblclick: function($event) {
                              _vm.showAdvanceTextDialog(
                                _vm.$t("SeaExport.NotifyParty"),
                                _vm.mergeNotifyLine(),
                                _vm.splitNotifyLine,
                                _vm.notUppercaseShipperConsigneNotify
                              )
                            }
                          },
                          model: {
                            value: _vm.job["notifyLine" + i],
                            callback: function($$v) {
                              _vm.$set(_vm.job, "notifyLine" + i, $$v)
                            },
                            expression: "job['notifyLine'+i]"
                          }
                        })
                      ],
                      1
                    )
                  }),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.ChineseDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "cargoChineseName",
                          disabled: !_vm.isEdit,
                          "auto-uppercase": false,
                          "auto-half-word": false
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                              _vm.job.cargoChineseName,
                              function(val) {
                                _vm.job.cargoChineseName = val
                              },
                              true,
                              { autoUppercase: true }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoChineseName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoChineseName", $$v)
                          },
                          expression: "job.cargoChineseName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "cargoEnglishName",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                              _vm.job.cargoEnglishName,
                              function(val) {
                                _vm.job.cargoEnglishName = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.HsCode") } },
                    [
                      _c("el-input", {
                        attrs: { no: "hsCode", type: "textarea", rows: 3 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.HsCode"),
                              _vm.job.hsCode,
                              function(val) {
                                _vm.job.hsCode = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.hsCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "hsCode", $$v)
                          },
                          expression: "job.hsCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Marks") } },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: {
                          height: "65px",
                          "min-height": "65px",
                          flex: "1"
                        },
                        attrs: {
                          no: "mark",
                          "text-chars": 0,
                          "warning-count": -1,
                          disabled: !_vm.isEdit,
                          "auto-uppercase": _vm.isUppercaseByConfig
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Marks"),
                              _vm.job.mark,
                              function(val) {
                                _vm.job.mark = val
                              },
                              _vm.isUppercaseByConfig,
                              { autoUppercase: _vm.isUppercaseByConfig }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.mark,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "mark", $$v)
                          },
                          expression: "job.mark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CategoryOfGoods") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoCode",
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          disabled: _vm.readonly,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.job.cargoCode,
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          no: "cargoName",
                          disabled: !(
                            _vm.isEdit &&
                            _vm.job.cargoCode != "" &&
                            _vm.job.cargoCode != null
                          )
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomsBroker") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsBroker",
                          disabled: !_vm.job.customs,
                          "select-type": _vm.TYPE_NAMES.basic_data_Company,
                          "data-filter-function": _vm.customsBrokerFilter,
                          filterable: "",
                          "default-value": _vm.job.customsBroker || "",
                          placeholder: _vm.$t(
                            "SeaExport.PleaseTickCustomsDeclarationOption"
                          ),
                          "method-params": {
                            customsBroker: true,
                            companyLob: "seaExport",
                            active: true
                          }
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.customsBrokerChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomsDeclarationType")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "customsDeclarationType",
                          disabled: !_vm.job.customs,
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CustomsDeclarationType,
                          filterable: "",
                          "default-value":
                            _vm.job.customsDeclarationType === -1
                              ? ""
                              : _vm.job.customsDeclarationType,
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customsDeclarationType = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isSalesForSzfs
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.HaulageCompany") }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              no: "landTransportation",
                              disabled: !_vm.job.landTransportation,
                              "method-params": { truckCmp: true, active: true },
                              "default-value": _vm.job.carryingCmp || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                              ),
                              "custom-style": "width:260px"
                            },
                            on: { change: _vm.carryingCmpChangeHandler }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.Door") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "doorName",
                            "value-key": "name",
                            clearable: "",
                            filterable: "",
                            "allow-create": true
                          },
                          on: { change: _vm.doorsChangeHandler },
                          model: {
                            value: _vm.truckingInfo.doorName,
                            callback: function($$v) {
                              _vm.$set(_vm.truckingInfo, "doorName", $$v)
                            },
                            expression: "truckingInfo.doorName"
                          }
                        },
                        _vm._l(_vm.doorList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.name }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("Payment.contactPerson") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "doorMan",
                              placeholder: _vm.$t("Payment.contactPerson")
                            },
                            model: {
                              value: _vm.truckingInfo.doorMan,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                              },
                              expression: "truckingInfo.doorMan"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "60px",
                                padding: "0 10px",
                                "font-size": "12px",
                                "text-align": "right"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                          ),
                          _c("el-input", {
                            staticClass: "short-el-input",
                            attrs: {
                              no: "doorManTel",
                              placeholder: _vm.$t("SeaExport.Tel")
                            },
                            model: {
                              value: _vm.truckingInfo.doorManTel,
                              callback: function($$v) {
                                _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                              },
                              expression: "truckingInfo.doorManTel"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.job.landTransportation,
                          expression: "job.landTransportation"
                        }
                      ],
                      attrs: { label: _vm.$t("SeaExport.DoorAddress") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "doorAddr", type: "textarea", rows: 3 },
                        model: {
                          value: _vm.truckingInfo.doorAddr,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                          },
                          expression: "truckingInfo.doorAddr"
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              ),
              _c(
                "el-form",
                {
                  attrs: {
                    disabled: _vm.readonly,
                    "label-width": "100px",
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.SecondNotifyParty") }
                    },
                    [
                      _c("cargo-rich-textarea", {
                        staticStyle: { width: "260px", height: "216px" },
                        attrs: {
                          no: "alsoNotify",
                          disabled: _vm.readonly,
                          "text-chars": 0
                        },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.SecondNotifyParty"),
                              _vm.job.alsoNotify,
                              function(val) {
                                _vm.job.alsoNotify = val
                              },
                              true,
                              { warningCount: 45, maxChar: 0 }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.alsoNotify,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "alsoNotify", $$v)
                          },
                          expression: "job.alsoNotify"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "auto-width" },
                    [
                      _c("special-requests-grid", {
                        ref: "selectedSpecialRequest",
                        attrs: {
                          no: "satisfiedRequests",
                          "is-edit": _vm.isEdit,
                          "customer-id": _vm.job.customerId,
                          lob: _vm.job.lob,
                          job: _vm.job
                        },
                        model: {
                          value: _vm.job.satisfiedRequests,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "satisfiedRequests", $$v)
                          },
                          expression: "job.satisfiedRequests"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.Remarks") }
                    },
                    [
                      _c("el-input", {
                        attrs: { no: "remarks", type: "textarea", rows: 4 },
                        nativeOn: {
                          dblclick: function($event) {
                            _vm.showAdvanceTextDialog(
                              _vm.$t("SeaExport.Remarks"),
                              _vm.job.remarks,
                              function(val) {
                                _vm.job.remarks = val
                              }
                            )
                          }
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField1") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField1",
                          type: "textarea",
                          rows: 4
                        },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField2") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField2",
                          type: "textarea",
                          rows: 4
                        },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField3") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField3",
                          type: "textarea",
                          rows: 4
                        },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { label: _vm.$t("SeaExport.UserDefinedField4") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "userDefinedField4",
                          type: "textarea",
                          rows: 4
                        },
                        model: {
                          value: _vm.job.userDefinedField4,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField4", $$v)
                          },
                          expression: "job.userDefinedField4"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TaxNature") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            no: "taxNature",
                            placeholder: _vm.$t("SeaExport.PleaseSelect"),
                            size: "mini"
                          },
                          model: {
                            value: _vm.job.taxNature,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "taxNature", $$v)
                            },
                            expression: "job.taxNature"
                          }
                        },
                        _vm._l(_vm.TAX_NATURES, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }